import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserDeviceService } from './../../../services/user-device.service';
import { StripeService } from '../../../services/stripe.service';
import { UserService } from './../../../services/user.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { first, map, tap, concatMap } from 'rxjs/operators';
import * as jquery from 'jquery';
import { UserNavigationComponent } from 'src/app/partials/navigation/user-navigation/user-navigation.component';

@Component({
  selector: 'app-replace-breathing-device',
  templateUrl: './replace-breathing-device.component.html',
  styleUrls: ['./replace-breathing-device.component.scss']
})
export class ReplaceBreathingDeviceComponent implements OnInit {

  @ViewChild(UserNavigationComponent) userNavigation;

  num: number;
  num2: string;
  total: any;
  subtotal: number;
  success = false;
  error = false;
  expireYear: string;
  expireMonth: string;
  lastFourDigits: number;
  deliveryAddress: string;
  hasPaymentMethod = false;
  modalText = 'Loading...';
  pending_request_error = 0;
  passwordForm: FormGroup;
  submitted = false;
  errorMsg: string;
  loading = 0;
  device_price: string;
  delivery_charge: string;

  constructor(
    private route: ActivatedRoute,
    private pageTitleService: Title,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private stripeService: StripeService,
    private userDeviceService: UserDeviceService
  ) { }

  ngOnInit(): void {
    this.setPageTitle();
    this.setFormControls();

    this.loadData();
    let top = document.getElementById('top');
    if (top !== null) {
      top.scrollIntoView();
      top = null;
    }
  }

  setPageTitle() {
    this.pageTitleService.setTitle(this.route.snapshot.data.title || 'Replace Breathing Device');
  }

  setFormControls() {
    this.passwordForm = this.formBuilder.group({
      password: ['', [Validators.required]]
    });
  }

  loadData() {

    // Show progress modal
    this.showProgressModal();

    this.userService.getProfile()
      .pipe(
        // Get User Details
        map(user => user.data.user),
        tap(user => {
          this.userNavigation.user = user;
        }),

        // Get Delivery Address
        concatMap(() => this.userService.getDeliveryAddress()),
        map(deliveryData => deliveryData.data),
        tap(deliveryData => {
          const address = deliveryData.delivery;
          const line1 = (address.line1) ? address.line1 + ' ' : '';
          const line2 = (address.line2) ? address.line2 + ' ' : '';
          const suburb = (address.suburb && address.suburb !== 'none') ? address.suburb + '' : '';
          const city = (address.city) ? ', ' + address.city + ', ' : '';
          const countryName = (address.country_name) ? address.country_name : '';
          this.deliveryAddress = line1 + line2 + suburb + city + countryName;

          this.delivery_charge = deliveryData.delivery_charge;
          this.device_price = deliveryData.device_price;
          this.subtotal = Number(this.device_price);
          let total = Number(this.device_price) + Number(this.delivery_charge);
          this.total = this.addZeroes(total);
        }),

        // Get Payment Method
        concatMap(() => this.stripeService.getPaymentMethod()),
        map(paymentData => paymentData.data),
        tap(paymentData => {
          const lastId = paymentData.methods.length - 1;
          this.lastFourDigits = paymentData.methods[lastId].last4;
          this.expireMonth = paymentData.methods[lastId].exp_m;
          this.expireYear = paymentData.methods[lastId].exp_y;
          this.hasPaymentMethod = true;
        }),

      )
      .subscribe(
        response => {
          if (response) {
            setTimeout(() => {
              // hide progress modal
              this.hideProgressModal();
            }, 500);
          }
        },
        error => {
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
        }
      );
  }

  addZeroes(num_param) {
    // Cast as number
    let num = Number(num_param);
    // If not a number, return 0
    if (isNaN(num)) {
      return 0;
    }
    // If there is no decimal, or the decimal is less than 2 digits, toFixed
    if (String(num).split(".").length < 2 || String(num).split(".")[1].length<=2 ){
      this.num2 = num.toFixed(2);
    }
    // Return the number
    return this.num2;
  }

  // convenience getter for easy access to form fields
  get f() { return this.passwordForm.controls; }

  computeTotal(event: any) {
    const noOfItems = event.target.value;
    if (noOfItems > 0) {
      this.subtotal = 9.99 * noOfItems;
      this.total = (9.99 * noOfItems) + 5;
    } else {
      this.subtotal = 0;
      this.total = 0;
    }
  }

  resetForm() {
    this.submitted = false;
    this.passwordForm.reset();
  }

  onPurchase() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.passwordForm.invalid) {
      return;
    }

    this.loading = 1;
    this.success = false;
    // Show progress modal
    this.showProgressModal();
    this.modalText = 'Saving...';
    this.pending_request_error = 0;

    this.userDeviceService.request(this.f.password.value)
      .pipe(first())
      .subscribe(
        data => {
          //console.log(data);
          setTimeout(() => {
            // hide progress modal
            this.hideProgressModal();
          }, 500);

          if (data.success) {
            jquery('.close').click();
            this.success = true;
            setTimeout(() => {
              this.success = false;
            }, 5000);
          } else {
            //console.log(data.error.msg);
            if (data.error.msg) {
              this.errorMsg = data.error.msg;
              this.pending_request_error = 1;
              setTimeout(() => {
                this.pending_request_error = 0;
              }, 4000);
            } else {
              this.f.password.setErrors({'error': true});
              this.f.password.setErrors({'invalid': true});
            }

          }
          this.loading = 0;
        },
        error => {
          //console.log(error);
          // hide progress modal
          this.hideProgressModal();
          this.error = true;
          this.loading = 0;
        }
      );

  }

  private showProgressModal() {
    jquery('#loaderSpin').show();
  }

  private hideProgressModal() {
    jquery('#loaderSpin').hide();
  }
}
